import { Route, useLocation, Navigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'

import User from 'singletons/User'
import {
  DASHBOARD_SCHEDULE,
  DASHBOARD_QUEUE,
  VISIT_VIEW,
  ACCOUNT,
  ACCOUNT_CHANGE_PASSWORD,
  DASHBOARD,
  DASHBOARD_VISITS,
  DASHBOARD_PASTVISITS,
  RX_CHANGE_REQUEST,
  DASHBOARD_POLICIES,
  DASHBOARD_PAYMENTS,
  HELP_CENTER,
  DASHBOARD_MEMBERS,
  DASHBOARD_SCHEDULE_V1,
  DASHBOARD_REPORTS,
} from 'constants/routing'

import Home from './Home'
import Queue from './Queue'
import Visit from './Visit'
import Account from './Account'
import ChangePassword from './Account/ChangePassword'
import GeneralPanel from './GeneralPanel'
import PastVisits from './PastVisits'
import RxChangeRequest from './RxChangeRequest'
import HelpCenter from './HelpCenter'
import Payments from './Payments'
import Policies from './Policies'

import useStyles from './styles'
import Members from './Members'
import { APMRoutes } from 'util/apm'
import Schedule from './Schedule'
import ScheduleNew from './ScheduleNew'
import { SelectedMemberProvider, useSelectedMember } from './Members/SelectedMemberProvider'
import Reports from './Reports'

const ConnectedPanel = observer(() => {
  /* White list mode */
  const { pathname } = useLocation()
  const { provider } = User
  const { selectedMemberName } = useSelectedMember()

  /*
  Simplest implementation; now subroutes are not supported.
  /visit/... routes should not have GeneralPanel panel shown.
  Adam told, that consumers of this app are old and there should not be too much info shown.
  + doctors, who have already entered visit, must think about patient, not about logging out)
*/
  const DASHBOARD_TITLES = {
    [DASHBOARD]: `Welcome`,
    [DASHBOARD_SCHEDULE_V1]: 'Schedule',
    [DASHBOARD_SCHEDULE]: 'Schedule',
    [DASHBOARD_QUEUE]: 'Queue',
    [DASHBOARD_MEMBERS]: selectedMemberName ? `Members / ${selectedMemberName}` : 'Members',
    [HELP_CENTER]: 'Help Center',
    [DASHBOARD_PAYMENTS]: 'Payments',
    [ACCOUNT]: 'Account',
    [ACCOUNT_CHANGE_PASSWORD]: 'Account > Change password',
    [DASHBOARD_VISITS]: User.isMedicationSafetyPhase2FlagEnabled ? 'Past Visits' : 'Visits',
    [DASHBOARD_POLICIES]: 'Policies',
    [DASHBOARD_REPORTS]: 'Reports',
    [DASHBOARD_PASTVISITS]: 'Visits > Past Visits',
    [RX_CHANGE_REQUEST]: 'RX Change Requests',
  }

  return provider && DASHBOARD_TITLES[pathname] ? (
    <GeneralPanel
      title={pathname === DASHBOARD ? `Welcome, ${User.provider.welcomeTitle}` : DASHBOARD_TITLES[pathname]}
    />
  ) : null
})

const Main = observer(() => {
  const classes = useStyles()
  return (
    <SelectedMemberProvider>
      <div className={classes.root}>
        <ConnectedPanel />
        <APMRoutes>
          <Route exact="true" path={DASHBOARD} element={<Home />} />
          <Route exact="true" path={DASHBOARD_SCHEDULE_V1} element={<Schedule />} />
          <Route exact="true" path={DASHBOARD_SCHEDULE} element={<ScheduleNew />} />
          <Route exact="true" path={DASHBOARD_QUEUE} element={<Queue />} />
          <Route exact="true" path={DASHBOARD_MEMBERS} element={<Members />} />
          <Route path={VISIT_VIEW} element={<Visit />} />
          <Route exact="true" path={ACCOUNT} element={<Account />} />
          <Route exact="true" path={ACCOUNT_CHANGE_PASSWORD} element={<ChangePassword />} />
          <Route exact="true" path={DASHBOARD_VISITS} element={<PastVisits />} />
          <Route exact="true" path={DASHBOARD_POLICIES} element={<Policies />} />
          <Route exact="true" path={HELP_CENTER} element={<HelpCenter />} />
          <Route exact="true" path={User.provider?.paymentVisible ? DASHBOARD_PAYMENTS : ' '} element={<Payments />} />
          <Route exact="true" path={DASHBOARD_PASTVISITS} element={<Queue />} />
          <Route exact="true" path={RX_CHANGE_REQUEST} element={<RxChangeRequest />} />
          <Route exact="true" path={DASHBOARD_REPORTS} element={<Reports />} />
          <Route path={'*'} element={<Navigate to={DASHBOARD} replace />} />
        </APMRoutes>
      </div>
    </SelectedMemberProvider>
  )
})

export default Main
